import { http } from '@/http'

export default {
  list()             { return http.get('/pension-entities') },
  get(id)            { return http.get(`/pension-entities/${id}`) },
  save(data)         { return http.post('/pension-entities', data) },
  update(id, data)   { return http.put(`/pension-entities/${id}`, data) },
  changeStatus(id, status) {
    return http.put(`/pension-entities/${id}/status`, null, { params: { status } })
  },
}
